export const menuItems = [
  { name: "My Profile", routerPath: "/my-shopper/myProfile" },
  { name: "My Bids", routerPath: "/my-shopper/myBids" },
  { name: "My Upcoming Auctions", routerPath: "/my-shopper/watchComProperties" },
  { name: "My Purchase Profiles", routerPath: "/my-shopper/purchaseProfile" },
  { name: "My Offers", routerPath: "/my-shopper/myOffers" },
  { name: "Saved Searches", routerPath: "/my-shopper/savedSearches" },
  { name: "Favorites", routerPath: "/my-shopper/watchProperties" },
];

export const CutomerCare = [
  {
    name: "Cutomer Care",
    routerPath: "/sellerAdmin/cust-care",
  },
];
